import React, { useState, useEffect } from "react";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";
import { data } from "jquery";
import actions from "redux-form/lib/actions";

const PayPal = (props) => {

    const initialOptions={
        "client-id":"AXXNuvJ0WxfKndTFF_kSzraY-IzX4SvWfTfI0WNJJjdP6_Dw0jHOpY3_qhyiJX3mz7Ygl8VN-dNMmewH",
        currency:"Euro",
        intent:"capture",
        
        
    }

    const createOrder = (data, actions) =>{
        return actions.order.create({
            purchase_units:[
                {
                    description:"FRANCISCOGUITAR.CH Sheetmusic & Videos",
                    amount:{
                        currency_code:'EUR',
                        value:props.value
                    }

                }
            ]
        })

    }

    const onApprove = (data, actions)=>{
        return actions.order.capture()
        .then(
            function(details){
                console.log(details)
                console.log("Transaction completed by " ,   details.payer.name.given_name)
                console.log("Muschi-status:", details.status)
                if (details.status==="COMPLETED"){
                    props.produkteZuordnen(details)
                }
                

                /*details:
                {
    "id": "7TD73529LM521493E",
    "intent": "CAPTURE",
    "status": "COMPLETED",
    "purchase_units": [
        {
            "reference_id": "default",
            "amount": {
                "currency_code": "EUR",
                "value": "0.10"
            },
            "payee": {
                "email_address": "info@herbertdapper.de",
                "merchant_id": "BDQHYRUNR4LDJ"
            },
            "description": "FRANCISCOGUITAR.CH Sheetmusic & Videos",
            "soft_descriptor": "PAYPAL *COMPASBUILD",
            "shipping": {
                "name": {
                    "full_name": "Herbert Dapper"
                },
                "address": {
                    "address_line_1": "Villingen-Schwenningen",
                    "address_line_2": "Ringstr. 3",
                    "admin_area_2": "Villingen-Schwenningen",
                    "postal_code": "78052",
                    "country_code": "DE"
                }
            },
            "payments": {
                "captures": [
                    {
                        "id": "5GX86388FA779441K",
                        "status": "COMPLETED",
                        "amount": {
                            "currency_code": "EUR",
                            "value": "0.10"
                        },
                        "final_capture": true,
                        "seller_protection": {
                            "status": "ELIGIBLE",
                            "dispute_categories": [
                                "ITEM_NOT_RECEIVED",
                                "UNAUTHORIZED_TRANSACTION"
                            ]
                        },
                        "create_time": "2025-06-15T23:04:51Z",
                        "update_time": "2025-06-15T23:04:51Z"
                    }
                ]
            }
        }
    ],
    "payer": {
        "name": {
            "given_name": "Herbert",
            "surname": "Dapper"
        },
        "email_address": "herbert.dapper@estrella-software.de",
        "payer_id": "ZBHYYJ2WC3EB6",
        "address": {
            "country_code": "DE"
        }
    },
    "create_time": "2025-06-15T23:03:15Z",
    "update_time": "2025-06-15T23:04:52Z",
    "links": [
        {
            "href": "https://api.paypal.com/v2/checkout/orders/7TD73529LM521493E",
            "rel": "self",
            "method": "GET"
        }
    ]
}*/
            }
        )
    }


    const styles = {
	        shape: "rect",
	        layout: "vertical",
            label:"buynow"
	}

   

   return (
        <PayPalScriptProvider 
            options={
                { 
                    "client-id": "Ab3yPSm_akgGypWhKU3RcsSQkBMDIRrC5BAHmu5RUqjy9s1D6vXrIvXQ6rXVkNT4fhqJ9V9dvXTUy8vV", 
                    currency:'EUR', 
                    intent:'capture',      
                    components: "buttons,applepay",

                }            
            }
        >
            
            
        <PayPalButtons
            createOrder={(data, actions) =>createOrder(data, actions) }
            onApprove={(data, actions) => onApprove(data, actions) }
            style={styles}
            
            
        />
       

        </PayPalScriptProvider>
    )
    

  
}

export default PayPal;